import DropdownLangMobile from "./dropdownLangMobile";

// Keep desktop and mobile language selectors on the same UI/behavior.
// The shared component renders its popup through a portal, so it is not
// clipped by header overflow/z-index on either layout.
const DropdownLang = () => <DropdownLangMobile />;

export default DropdownLang;
